<div class="acc-application-status-log-dialog-part">
	<div class="d-flex flex-column gap-2">
		<h4>Current Status</h4>
		<div class="d-flex flex-column gap-2">
			<!-- New Dashboard Descriptive Select Field -->
			<div>
				<!-- Hidden original select field to maintain form registration -->
				<div class="d-none">
					<common-select-field [field]="form.toAccApplicationStatusId()"></common-select-field>
				</div>
				<dashboard-descriptive-select-field [showSubTextInValue]="false" [items]="form.descriptiveStatusItems()"
					[selectedItem]="form.selectedDescriptiveItem()" [placeholder]="'Select a status...'"
					[label]="'Status (New Widget Test)'" [disabled]="!form.isDescriptiveSelectEnabled()"
					[customIcon]="form.currentStatusIcon()" [enableSorting]="false"
					(selectionChange)="form.onDescriptiveSelectionChange($event)">
				</dashboard-descriptive-select-field>
			</div>
			<div class="my-3 d-flex flex-row gap-2">
				<input class="form-check-input fs-6" type="checkbox" name="field-checkbox-deferApplication"
					id="deferApplicationCheckBox" [ngModel]="form.deferApplication()"
					(ngModelChange)="form.onChangeDeferApplication($event)" [disabled]="form.deferCheckboxDisabled()" />
				<label class="form-check-label" for="deferApplicationCheckBox">
					Defer the applicant to be a prospect in the next trimester
				</label>
			</div>
			<common-text-field [field]="form.note()"></common-text-field>

			<common-button-row [center]="true">
				<button #statusSaveBtn class="btn btn-standard mt-2" [disabled]="form.disableSaveBtn()">
					Save Status
				</button>
			</common-button-row>
		</div>
	</div>
</div>